module.exports = __webpack_public_path__ + "static/media/btr.cefeae3f.png";